import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import SidebarSupportSubItem from '../../components/common/SidebarSupportSubItem';
import { isHasPermissionWithMenu } from '../../utils/utils';
import { permissionList } from '../../utils/constants';

class Sidebar extends Component {
  state = {};
  // eslint-disable-next-line lines-between-class-members
  render() {
    const { permissionsOrder } = this.props;
    if (!isHasPermissionWithMenu({ permissions: permissionsOrder, listKeys: permissionList.orderManagement }))
      return null;
    const { isExpand, sideProps } = this.props;
    sideProps.isExpand = isExpand;
    return <SidebarSupportSubItem {...sideProps} isMaximizeOne />;
  }
}

// export default Sidebar;
const mapStateToProps = store => {
  const layoutReducer = store.get('layout');
  const { sidebarExpanded } = layoutReducer ? layoutReducer.toJS() : { sidebarExpanded: true };
  const permissionsOrder = store.get('auth').toJS().permissionsApp.customerHubModules;

  return {
    isExpand: sidebarExpanded,
    permissionsOrder: permissionsOrder.length
      ? permissionsOrder.filter(a => a.moduleName === 'ORDER_MANAGEMENT')[0]
      : {},
  };
};
const mapDispatchToProps = dispatch => ({
  dispatch,
});

Sidebar.propTypes = {
  isExpand: PropTypes.bool,
  sideProps: PropTypes.objectOf(PropTypes.any),
};

Sidebar.defaultProps = {
  isExpand: true,
  sideProps: {},
};

export default connect(mapStateToProps, mapDispatchToProps)(Sidebar);
